import { RootState } from '@/domain/store';

export const selectProjectVenuesDates = (state: RootState) => {
  return state.projectVenueDates.items;
};

export const selectProjectVenueDateById =
  (id: number) => (state: RootState) => {
    const projectVenueDate = state.projectVenueDates.items.find(
      (date) => date.id === id,
    );
    return projectVenueDate;
  };

export const selectProjectVenueIsImportingDates = (state: RootState) => {
  return state.projectVenueDates.isImportingDates;
};

export const selectProjectVenueIsCreatingDates = (state: RootState) => {
  return state.projectVenueDates.isCreatingDates;
};
